<template>
  <div>
    <!-- BEGIN #header -->
    <div id="header" class="app-header" v-bind:class="{ 'app-header-inverse': appOptions.appHeaderInverse }">
      <!-- BEGIN navbar-header -->
      <div class="navbar-header">
        <button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarEndMobile"
          v-if="appOptions.appSidebarTwo">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <router-link to="/" class="navbar-brand"><span v-html="siteName"></span>
        </router-link>
        <button type="button" class="navbar-mobile-toggler" v-on:click="toggleTopMenuMobile"
          v-if="appOptions.appTopMenu && !appOptions.appSidebarNone">
          <span class="fa-stack fa-lg text-inverse">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
        <button type="button" class="navbar-mobile-toggler" v-on:click="toggleTopMenuMobile"
          v-if="appOptions.appTopMenu && appOptions.appSidebarNone">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
        <button type="button" class="navbar-mobile-toggler" v-on:click="toggleHeaderMegaMenuMobile"
          v-if="appOptions.appHeaderMegaMenu">
          <span class="fa-stack fa-lg text-inverse m-t-2">
            <i class="far fa-square fa-stack-2x"></i>
            <i class="fa fa-cog fa-stack-1x"></i>
          </span>
        </button>
        <button type="button" class="navbar-mobile-toggler" v-on:click="toggleSidebarMobile"
          v-if="!appOptions.appSidebarNone">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <!-- END navbar-header -->


      <!-- BEGIN header-nav -->
      <div class="navbar-nav">
        <header-mega-menu v-if="appOptions.appHeaderMegaMenu"></header-mega-menu>


        <b-nav-item-dropdown @show="$router.push('/support').catch(() => { });" class="navbar-item"
          menu-class="dropdown-menu media-list" right toggle-class="navbar-link dropdown-toggle icon" no-caret>
          <template slot="button-content">
            <i class="fas fa-message"></i>
            <span v-show="user.support_messages" class="badge bg-danger">{{ user.support_messages }}</span>
          </template>
        </b-nav-item-dropdown>
        <b-nav-item-dropdown class="navbar-item" menu-class="dropdown-menu media-list" right
          toggle-class="navbar-link dropdown-toggle icon" no-caret @show="fetchNotify">
          <template slot="button-content">
            <i class="fa fa-bell"></i>
            <span v-if="user.notifications" class="badge bg-danger">{{ user.notifications > 9 ? '+' : user.notifications
            }}</span>
          </template>
          <div class="dropdown-header">Уведомления:</div>
          <div v-if="!notifications.length" class="text-center text-gray-700">Уведомлений нет </div>
          <a v-for="(notification, index)  in notifications" :key="index"
            @click="$router.push(notification.link).catch(() => { });" class="dropdown-item media "
            :class="(notification.viewed) ? '' : ((user.theme) ? 'bg-gray-600' : 'bg-gray-200')">
            <div class="media-left">
              <img onerror="javascript:this.src='/assets/img/user/user-5.jpg'" alt=""
                :src="`/images/avatar/` + notification.user.avatar" class="user-avatar" width="50" height="50" />
              <!--<i class="fas  fa-circle-check text-green media-object-icon"></i>-->
            </div>
            <div class="media-body cursor-pointer">
              <h6 class="media-heading">{{ notification.user.name }}</h6>
              <p>{{ notification.message }}</p>
              <div class="text-muted fs-10px">{{ notification.created_at }}</div>
            </div>
          </a>
          <!--
					<a href="javascript:;" class="dropdown-item media">
						<div class="media-left">
							<img src="/assets/img/user/user-2.jpg" class="media-object" alt="" />
							<i class="fa fa-exclamation-circle text-red media-object-icon"></i>
						</div>
						<div class="media-body">
							<h6 class="media-heading">Модератор</h6>
							<p>Ваше задание отклонено</p>
							<div class="text-muted fs-10px">55 minutes ago</div>
						</div>
					</a>
					-->
          <div class="dropdown-footer text-center">
            <a class="text-decoration-none cursor-pointer"
              @click="$router.push({ name: 'NotificationList' }).catch(() => { });">Показать
              все</a>
          </div>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown right menu-class="me-1" class="navbar-item navbar-user dropdown"
          toggle-class="navbar-link dropdown-toggle d-flex align-items-center" no-caret>
          <template slot="button-content">

            <img onerror="javascript:this.src='/images/avatar/user.png'" :src="`/images/avatar/${user.avatar}`" alt=""
              width="50" height="50" class="user-avatar">
            <span v-if="user.name" class="d-none d-md-inline">{{ user.name }}</span> <b class="caret"></b>
          </template>
          <a href="/#/mypage" class="dropdown-item">Моя страница</a>
          <a href="/#/rating" class="dropdown-item">Рейтинг</a>
          <a href="/#/profile" class="dropdown-item">Настройки</a>
          <a href="/#/password" class="dropdown-item">Сменить пароль</a>
          <div class="dropdown-divider"></div>
          <a href="/#/logout" class="dropdown-item">Выйти</a>
        </b-nav-item-dropdown>
        <div class="navbar-divider d-none d-md-block" v-if="appOptions.appSidebarTwo"></div>
        <div class="navbar-item d-none d-md-block" v-if="appOptions.appSidebarTwo">
          <a href="javascript:;" v-on:click="toggleSidebarEnd" class="navbar-link icon">
            <i class="fa fa-th"></i>
          </a>
        </div>
      </div>
      <!-- end header navigation right -->
    </div>
    <!-- end #header -->
  </div>
</template>

<script>
import AppOptions from '../../config/AppOptions.vue'
import HeaderMegaMenu from './HeaderMegaMenu.vue'
import HTTP from "../../http";
import {show_error} from "../../message";

export default {
  name: 'Header',
  components: {
    HeaderMegaMenu
  },
  data() {
    return {
      appOptions: AppOptions,
      siteName: '',
      user: {avatar: null, notifications: 0, support_messages: 0},
      notifications: [],
      notification: 0
    }
  },
  created() {
    this.siteName = process.env.VUE_APP_SITE_NAME
    if (localStorage.user) {
      this.user = JSON.parse(localStorage.getItem('user'))
    }
    window.eventBus.$on('user.update', resp => {
      this.user = resp
    })

  },
  methods: {
    toggleSidebarMobile() {
      this.appOptions.appSidebarMobileToggled = !this.appOptions.appSidebarMobileToggled;
    },
    toggleSidebarEnd() {
      this.appOptions.appSidebarEndToggled = !this.appOptions.appSidebarEndToggled;
    },
    toggleSidebarEndMobile() {
      this.appOptions.appSidebarEndMobileToggled = !this.appOptions.appSidebarEndMobileToggled;
    },
    toggleTopMenuMobile() {
      this.appOptions.appTopMenuMobileToggled = !this.appOptions.appTopMenuMobileToggled;
    },
    toggleHeaderMegaMenuMobile() {
      this.appOptions.appHeaderMegaMenuMobileToggled = !this.appOptions.appHeaderMegaMenuMobileToggled;
    },
    checkForm: function (e) {
      e.preventDefault();
      this.$router.push({path: '/extra/search'})
    },

    fetchNotify() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .get("/notification/0")
        .then((resp) => {
          console.log('resp', resp)
          this.notifications = resp.data
          this.user.notifications = 0;

          let user = JSON.parse(localStorage.getItem('user'))

          user.notifications = 0;
          console.log('user', user)
          localStorage.setItem('user', JSON.stringify(user))
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
  }
}
</script>



<style>
.app-header .navbar-nav .navbar-item.show>a,
.app-header .navbar-nav .navbar-item.show>a:focus,
.app-header .navbar-nav .navbar-item.show>a:hover {
  background: 0 0;
  color: #adb5bd !important;
  opacity: 1;
}
</style>